import { ComboboxList } from '@reach/combobox';
import React__default from 'react';
import styled from 'styled-components';
import { COLOR_PALETTE } from '../colors/colorPalette.js';
import { Box } from '../layout/Box.js';

const MAX_COMBOBOX_SEARCH_RESULTS = 50;
const StyledComboboxNoResults = styled(Box)`
  height: 2.5rem;
  padding: 0 1rem;
  justify-content: center;
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
  color: ${COLOR_PALETTE.slateGrey40};
`;
/**
 * Combobox list.
 * Used for compositionally creating a `Combobox`
 *
 * @deprecated - use `SelectInput` with an onSearch handler instead
 */ const DEPRECATED_ComboboxList = ({ totalOptions , children  })=>{
    return React__default.createElement(React__default.Fragment, null, totalOptions > 0 && React__default.createElement(ComboboxList, {
        persistSelection: true
    }, children, totalOptions > MAX_COMBOBOX_SEARCH_RESULTS && React__default.createElement(StyledComboboxNoResults, null, "+ ", totalOptions - MAX_COMBOBOX_SEARCH_RESULTS, " Further options")), totalOptions === 0 && React__default.createElement(StyledComboboxNoResults, null, "No options"));
};
DEPRECATED_ComboboxList.dataId = "data-hpy-web-combobox-list";
DEPRECATED_ComboboxList.displayName = "ComboboxList";

export { DEPRECATED_ComboboxList };
